import React from 'react';
import './techLogoHolder.css'

function C2wTechLogoHolder({obj, type=0}) {
  return (
    <div className='C2wTeachnologyCard_div_superx'>
      <div className={ type === 0 ? 'C2wTeachnologyCard_superx' : 'C2wTeachnologyCard_superx_2'}>
          <img className='logoholder_img' src={`/assets/superx/images/${obj.imageName}.png`} />
      </div>
        <span>{obj?.title}</span>
    </div>
  )
}
export default C2wTechLogoHolder
